import React from 'react';
import PropTypes from 'prop-types';
import colors from 'common/styles/colors';
import OrgShareBySiteWidget from './OrgShareBySiteWidget';

const WIDGET_NAME = 'org_sites_by_site';

const OrgSitesBySite = props => (
  <OrgShareBySiteWidget
    {...props}
    widgetName={WIDGET_NAME}
    siteLinkTo="/assets"
    emptyMessageKey="orgView.sitesBySite.noData"
    emptyMessageDefault="No site data"
    noSitesMessageKey="orgView.sitesBySite.noSites"
    noSitesMessageDefault="No sites in this organisation"
    summaryLabelKey="orgView.sitesBySite.orgSummary"
    summaryLabelDefault="Organisation sites"
    getSummaryValue={summary => summary.sites_count}
    getSiteValue={site => site.machines}
    renderSummaryMeta={(t, summary) => t('orgView.sitesBySite.meta', {
      machines: summary.total_machines != null ? summary.total_machines : 0,
      defaultValue: '{{machines}} machines across sites'
    })}
    barColor={colors.normal}
    requireSites={false}
  />
);

OrgSitesBySite.propTypes = {
  organisationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  widgetsMetadata: PropTypes.object,
  title: PropTypes.string
};

OrgSitesBySite.defaultProps = {
  widgetsMetadata: null,
  title: null
};

export default OrgSitesBySite;
